/*
  Native wishlist (replaces Wishlist Plus / Swym).
  Saved in the shopper's browser (localStorage) as a list of product handles, newest first.

  [data-wishlist-toggle="handle"]  heart buttons (product page, product cards)
  [data-wishlist-count]            count badge (header)
  [data-wishlist-page]             the wishlist page, rendered from /products/<handle>.js
*/
(function() {
  var KEY = 'onebyone:wishlist';
  var configEl = document.getElementById('WishlistConfig');
  var strings = configEl ? JSON.parse(configEl.textContent) : {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    sync();
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read().filter(function(h) { return h !== handle; });
    if (!has(handle)) list.unshift(handle);
    write(list);
  }

  function remove(handle) {
    write(read().filter(function(h) { return h !== handle; }));
  }

  function money(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(button) {
      var saved = list.indexOf(button.getAttribute('data-wishlist-toggle')) !== -1;
      button.setAttribute('aria-pressed', saved);
      button.classList.toggle('is-saved', saved);
      var label = button.querySelector('[data-wishlist-label]');
      var text = saved ? strings.saved : strings.add;
      // Only touch text when it changes, so the MutationObserver below doesn't loop.
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function(badge) {
      if (badge.textContent !== String(list.length)) badge.textContent = list.length;
      badge.hidden = list.length === 0;
    });
  }

  function card(product) {
    var variants = product.variants.filter(function(v) { return v.available; });
    var options = '';
    if (variants.length > 1) {
      options = '<select class="wishlist-page__select" data-wishlist-variant aria-label="' + escapeHtml(product.options[0] ? product.options[0].name : strings.choose) + '">' +
        '<option value="">' + escapeHtml(product.options[0] ? product.options[0].name : strings.choose) + '</option>' +
        variants.map(function(v) { return '<option value="' + v.id + '">' + escapeHtml(v.title) + '</option>'; }).join('') +
        '</select>';
    }
    var image = product.featured_image
      ? '<img src="' + escapeHtml(product.featured_image.replace(/(\.[^.?]*)(\?|$)/, '_540x$1$2')) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '';
    var price = money(product.price) +
      (product.compare_at_price > product.price ? ' <s>' + money(product.compare_at_price) + '</s>' : '');
    var action = variants.length
      ? options + '<button type="button" class="btn btn--small" data-wishlist-add data-variant="' + (variants.length === 1 ? variants[0].id : '') + '">' + escapeHtml(strings.addToCart) + '</button>'
      : '<span class="wishlist-page__sold-out">' + escapeHtml(strings.soldOut) + '</span>';

    return '<div class="wishlist-page__item" data-handle="' + escapeHtml(product.handle) + '">' +
      '<a class="wishlist-page__image" href="' + escapeHtml(product.url) + '">' + image + '</a>' +
      '<button type="button" class="wishlist-page__remove" data-wishlist-remove="' + escapeHtml(product.handle) + '">' + escapeHtml(strings.remove) + '</button>' +
      '<a class="wishlist-page__title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
      '<div class="wishlist-page__price">' + price + '</div>' +
      '<div class="wishlist-page__actions">' + action + '</div>' +
      '</div>';
  }

  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var list = read();
    if (!list.length) {
      page.innerHTML = '<p class="wishlist-page__empty">' + escapeHtml(strings.empty) + '</p>';
      return;
    }

    Promise.all(list.map(function(handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    })).then(function(products) {
      // Drop products that no longer exist or were unpublished.
      var found = products.filter(Boolean);
      if (found.length !== list.length) {
        write(found.map(function(p) { return p.handle; }));
      }
      page.innerHTML = found.length
        ? '<div class="wishlist-page__grid">' + found.map(card).join('') + '</div>'
        : '<p class="wishlist-page__empty">' + escapeHtml(strings.empty) + '</p>';
    });
  }

  function addToCart(button) {
    var item = button.closest('.wishlist-page__item');
    var select = item.querySelector('[data-wishlist-variant]');
    var id = button.getAttribute('data-variant') || (select && select.value);
    if (!id) {
      select.focus();
      select.classList.add('is-invalid');
      return;
    }
    button.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function(r) {
      button.disabled = false;
      if (!r.ok) return;
      // Same event the theme uses after add to cart: rebuilds and opens the cart drawer.
      if (window.jQuery && theme.settings.cartType === 'drawer') {
        jQuery('body').trigger('added.ajaxProduct', button);
      } else {
        window.location.href = root + 'cart';
      }
    });
  }

  document.addEventListener('click', function(evt) {
    var toggleButton = evt.target.closest('[data-wishlist-toggle]');
    if (toggleButton) {
      evt.preventDefault();
      evt.stopPropagation();
      toggle(toggleButton.getAttribute('data-wishlist-toggle'));
      return;
    }
    var removeButton = evt.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      remove(removeButton.getAttribute('data-wishlist-remove'));
      removeButton.closest('.wishlist-page__item').remove();
      if (!read().length) renderPage();
      return;
    }
    var addButton = evt.target.closest('[data-wishlist-add]');
    if (addButton) addToCart(addButton);
  }, true);

  // Keep other open tabs in step.
  window.addEventListener('storage', function(evt) {
    if (evt.key === KEY) sync();
  });

  // Quick shop modals and filtered grids are added after load.
  var syncQueued = false;
  new MutationObserver(function() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function() {
      syncQueued = false;
      sync();
    });
  }).observe(document.body, { childList: true, subtree: true });

  sync();
  renderPage();
})();
